import React, { useCallback, useEffect, useState } from 'react';

interface Props {
    text: string;
    className: string;
}

const TitleSplit = (props: Props) => {
    const getParts = useCallback((text: string) => {
        const parts = text.trim().split(/\s+/);
        const part1 = parts.slice(0, 2).join(' ');
        const part2 = parts.slice(2).join(' ');

        return [part1, part2];
    }, []);

    const [parts, setParts] = useState(getParts(props.text));

    useEffect(() => setParts(getParts(props.text)), [getParts, props.text]);

    return (
        <span className={props.className}>
            <span dangerouslySetInnerHTML={{ __html: parts[0] }} />
            {' '}
            <span className="display-block-xs" dangerouslySetInnerHTML={{ __html: parts[1] }} />
        </span>
    );
};

export default TitleSplit;
